import {
  defaultUserSettings,
  USER_SETTINGS_STORAGE_KEY,
  UserSettingsSchema,
  type UserSettings,
} from '@pn/core/domain/settings';
import { webStorageService } from '@pn/services/storage/webStorageService';
import { isEmpty, isObject } from 'lodash-es';

/**
 * Validate the candidate (typically from the API) and return it if valid.
 * If not valid, try the settings from local storage.
 * If still not valid, return the default ones.
 */
export function deduceUserSettings(candidate: unknown): UserSettings {
  if (isEmpty(candidate)) return defaultUserSettings;

  const parsedCandidate = UserSettingsSchema.safeParse(candidate);
  if (parsedCandidate.success) return parsedCandidate.data;

  console.warn('Invalid user settings from API', parsedCandidate.error);

  const lsSettings = webStorageService('pn').get<UserSettings>(
    USER_SETTINGS_STORAGE_KEY
  );
  const parsedLsSettings = UserSettingsSchema.safeParse(lsSettings);
  if (parsedLsSettings.success) return parsedLsSettings.data;

  return {
    ...defaultUserSettings,
    ...rescueValidFields(candidate),
  };
}

function rescueValidFields(candidate: unknown): Partial<UserSettings> {
  if (!isObject(candidate)) return {};

  const result: Partial<UserSettings> = {};

  if ('unitSystem' in candidate) {
    const parsedUnitSystem = UserSettingsSchema.shape.unitSystem.safeParse(
      candidate.unitSystem
    );
    if (parsedUnitSystem.success) {
      result.unitSystem = parsedUnitSystem.data;
    }
  }

  if ('mapMode' in candidate) {
    const parsedMapMode = UserSettingsSchema.shape.mapMode.safeParse(
      candidate.mapMode
    );
    if (parsedMapMode.success) {
      result.mapMode = parsedMapMode.data;
    }
  }

  return result;
}
